
<div class="grid field col-12">
  <h1>Workbook Log</h1>
  @if (!everythingReady) {
    <p-progressSpinner></p-progressSpinner>
  }
</div>
<div class="grid col-12">
  <div class="col-12 md:col-2 mb-2">
    <button pButton  (click)="navigateToJobDetails()">
      <i pButtonIcon class="fa fa-edit"></i>
      <span pButtonLabel>Job Details</span>
    </button>
  </div>
  <div class="col-12 md:col-2">
    <button pButton  (click)="navigateToDashboard()">
      <i pButtonIcon class="fa fa-bar-chart"></i>
      <span pButtonLabel>Dashboard</span>
    </button>
  </div>
  <div class="col-12 md:col-2">
    <button pButton (click)="navigateToShiftSummaries()">
      <i pButtonIcon class="fa fa-clipboard-list"></i>
      <span pButtonLabel>Shift Summary</span>
    </button>
  </div>
  <div class="col-12 md:col-6">
    <button pButton type="button" (click)="dt.exportCSV()">
      <i pButtonIcon class="fa fa-download"></i>
      <span pButtonLabel>Export</span>
    </button>
  </div>
  <div class="col-12 pr-0">
    <p-table #dt
      [columns]="getAllColumns()"
      [value]="workbookData"
      [resizableColumns]="true"
      columnResizeMode="expand"
      [scrollable]="true" scrollHeight="calc(100vh - 325px)"
      [loading]="!everythingReady">
      <!-- <ng-template #colgroup let-columns>
      <colgroup>
      <col *ngFor="let col of columns" [style.width]="col.width" />
    </colgroup>
  </ng-template> -->
  <ng-template #header let-columns>
    <tr style="height:45px;">
      @for (col of columns; track col) {
        <th pResizableColumn pFrozenColumn  [frozen]="col.frozen"  [ngStyle]="{'display':col.display}"
          [pTooltip]="col.header" tooltipPosition="top" tooltipEvent="hover">
          {{col.header}}
        </th>
      }
    </tr>
    <tr style="height:31px;">
      @for (col of columns; track col) {
        <th pFrozenColumn  [frozen]="col.frozen" [ngStyle]="{'display':col.display}">
          {{col.unit}}
        </th>
      }
    </tr>
  </ng-template>
  <ng-template #body let-workbookLog let-columns="columns">
    <tr>
      @for (col of columns; track col) {
        <td pFrozenColumn  [frozen]="col.frozen" [ngStyle]="{'display':col.display}">
          @if (col.field == 'icons') {
            <div >
              @if (isVendor()) {
                <i class="far fa-edit actionIcon mr-1 mb-1 fa-xl" (click)="navigateToDetail(workbookLog)" style="margin-right:5px;"></i>
              }
              @if (isVendor() && isAdmin()) {
                <i class="far fa-trash-alt actionIcon mr-1 mb-1 fa-xl" (click)="confirmDelete(workbookLog)"></i>
              }
            </div>
          }
          @if (col.field == 'Time') {
            <div >
              {{workbookLog[col.field] | date: 'MM/dd/yy HH:mm'}}
            </div>
          }
          @if (col.field == 'relativeTime') {
            <div>
              {{workbookLog[col.field]  | number:'1.1-2'}}
            </div>
          }
          @if (col.field != 'Time' && col.field != 'relativeTime') {
            <div
              [pTooltip]="workbookLog[col.field]" tooltipPosition="top" tooltipEvent="hover">
              {{workbookLog[col.field]}}
            </div>
          }
        </td>
      }
    </tr>
  </ng-template>

</p-table>

</div>
<div class="col-12">
  <button pButton type="button" (click)="addWorkbookLog()" class="add-button" [disabled]="!isVendor()">
    <i pButtonIcon class="fa fa-plus"></i>
    <span pButtonLabel>Add Workbook Log</span>
  </button>
</div>
</div>
